const computePayToOwnerAmount = (
    totalPrice: number,
    handleDepositPayment: boolean | undefined,
    deposit: number,
    paymentPrice: number
) => totalPrice + (handleDepositPayment ? deposit : 0) - paymentPrice;

export default computePayToOwnerAmount;
